import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { EventsService } from 'src/app/events/shared/events.service';
import { SearchObjectResult } from 'src/app/shared/models/SearchObject';
import { Event } from 'src/app/shared/models/Event';
import { OfferService } from 'src/app/offers/shared/offer.service';
import { EventSearchCriteria } from 'src/app/events/shared/event-search-criteria.model';
import * as XLSX from "xlsx";

@Component({
    selector: 'app-statistics-events',
    templateUrl: './statistics-events.component.html',
    styleUrls: ['./statistics-events.component.scss'],
    standalone: false
})
export class StatisticsEventsComponent implements OnInit {

  public currentStatus: number = undefined;

  public columns: any;

  public additionalCosts;
  public eventOffers;

  filters: EventSearchCriteria = {};

  loadPage: (page: number, pageSize: number) => Observable<SearchObjectResult<Event>> = null;
  public tBodyTrAdditionalClass = 'alternateBgColor';

  @ViewChild('eventName', { static: true })
  eventName: TemplateRef<any>;

  @ViewChild('customerName', { static: true })
  customerName: TemplateRef<any>;

  @ViewChild('companyName', { static: true })
  companyName: TemplateRef<any>;

  @ViewChild('startDate', { static: true })
  startDate: TemplateRef<any>;

  @ViewChild('endDate', { static: true })
  endDate: TemplateRef<any>;

  @ViewChild('createdAt', { static: true })
  createdAt: TemplateRef<any>;

  @ViewChild('eventDays', { static: true })
  eventDays: TemplateRef<any>;

  @ViewChild('eventPrice', { static: true })
  eventPrice: TemplateRef<any>;

  @ViewChild('softwareWaiter', { static: true })
  softwareWaiter: TemplateRef<any>;

  @ViewChild('softwareCashRegister', { static: true })
  softwareCashRegister: TemplateRef<any>;

  @ViewChild('softwareMainDevice', { static: true })
  softwareMainDevice: TemplateRef<any>;

  @ViewChild('softwarePrinter', { static: true })
  softwarePrinter: TemplateRef<any>;

  @ViewChild('hardwarePhone', { static: true })
  hardwarePhone: TemplateRef<any>;

  @ViewChild('hardwareTablet', { static: true })
  hardwareTablet: TemplateRef<any>;

  @ViewChild('hardwarePrinter', { static: true })
  hardwarePrinter: TemplateRef<any>;

  @ViewChild('hardwareRouter', { static: true })
  hardwareRouter: TemplateRef<any>;

  @ViewChild('badWeather', { static: true })
  badWeather: TemplateRef<any>;

  @ViewChild('cancellation', { static: true })
  cancellation: TemplateRef<any>;

  @ViewChild('cashDrawer', { static: true })
  cashDrawer: TemplateRef<any>;

  @ViewChild('beltBag', { static: true })
  beltBag: TemplateRef<any>;

  @ViewChild('wallet', { static: true })
  wallet: TemplateRef<any>;

  @ViewChild('pickupInstalled', { static: true })
  pickupInstalled: TemplateRef<any>;

  @ViewChild('uploadingCheckingPricelist', { static: true })
  uploadingCheckingPricelist: TemplateRef<any>;

  @ViewChild('training', { static: true })
  training: TemplateRef<any>;

  @ViewChild('vivaWallet', { static: true })
  vivaWallet: TemplateRef<any>;

  @ViewChild('sumUp', { static: true })
  sumUp: TemplateRef<any>;

  @ViewChild('stockManagement', { static: true })
  stockManagement: TemplateRef<any>;

  @ViewChild('sticker', { static: true })
  sticker: TemplateRef<any>;

  @ViewChild('worldLine', { static: true })
  worldLine: TemplateRef<any>;

  @ViewChild('tapToPayHelp', { static: true })
  tapToPayHelp: TemplateRef<any>;

  constructor(private _eventsService: EventsService, private _offerService: OfferService) { }

  ngOnInit() {

    this.loadPage = (page: number, pageSize: number) => this._eventsService.search(page, pageSize, this.filters);

    this._eventsService.getAdditionalCostsAssigned().subscribe(res => {
      this.additionalCosts = res;
    });

    this._offerService.getAllEventOffers().subscribe(res => {
      this.eventOffers = res;
    })

    this.columns = [
      {
        name: 'eventName',
        displayed: true,
        translationKey: 'Event',
        template: this.eventName,
        sortable: true
      },
      {
        name: 'customerName',
        displayed: true,
        translationKey: 'Customer',
        template: this.customerName,
        sortable: true
      },
      {
        name: 'companyName',
        displayed: true,
        translationKey: 'Company',
        template: this.companyName,
        sortable: true
      },
      {
        name: 'startDate',
        displayed: true,
        translationKey: 'Start',
        template: this.startDate,
        sortable: true
      },
      {
        name: 'endDate',
        displayed: true,
        translationKey: 'Ende',
        template: this.endDate,
        sortable: true
      },
      {
        name: 'createdAt',
        displayed: true,
        translationKey: 'Erstellt',
        template: this.createdAt,
        sortable: true
      },
      {
        name: 'eventDays',
        displayed: true,
        translationKey: 'Tage',
        template: this.eventDays,
        sortable: true,
        additionalClass: 'text-center',
      },
      {
        name: 'eventPrice',
        displayed: true,
        translationKey: 'Vollpreis (€)',
        template: this.eventPrice,
        sortable: true,
        trAddidionalClass: 'text-center'
      },
      {
        name: 'softwareWaiter',
        displayed: true,
        translationKey: 'SW Kellner',
        template: this.softwareWaiter,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'softwareCashRegister',
        displayed: true,
        translationKey: 'SW Kassa',
        template: this.softwareCashRegister,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'softwareMainDevice',
        displayed: true,
        translationKey: 'SW Hauptgerät',
        template: this.softwareMainDevice,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'softwarePrinter',
        displayed: true,
        translationKey: 'SW Drucker',
        template: this.softwarePrinter,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hardwarePhone',
        displayed: true,
        translationKey: 'HW Handy',
        template: this.hardwarePhone,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hardwareTablet',
        displayed: true,
        translationKey: 'HW Tablet',
        template: this.hardwareTablet,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hardwarePrinter',
        displayed: true,
        translationKey: 'HW Drucker',
        template: this.hardwarePrinter,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hardwareRouter',
        displayed: true,
        translationKey: 'HW Router',
        template: this.hardwareRouter,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'badWeather',
        displayed: true,
        translationKey: 'Bad Weather',
        template: this.badWeather,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'cancellation',
        displayed: true,
        translationKey: 'Cancellation',
        template: this.cancellation,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'cashDrawer',
        displayed: true,
        translationKey: 'Cash Drawer',
        template: this.cashDrawer,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'beltBag',
        displayed: true,
        translationKey: 'Belt Bag',
        template: this.beltBag,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'wallet',
        displayed: true,
        translationKey: 'Wallet',
        template: this.wallet,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'pickupInstalled',
        displayed: true,
        translationKey: 'Pickup Installed',
        template: this.pickupInstalled,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'uploadCheckingPricelist',
        displayed: true,
        translationKey: 'Upload Checking Pricelist',
        template: this.uploadingCheckingPricelist,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'training',
        displayed: true,
        translationKey: 'Training',
        template: this.training,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'vivaWallet',
        displayed: true,
        translationKey: 'Viva Wallet',
        template: this.vivaWallet,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'sumUp',
        displayed: true,
        translationKey: 'Sum Up',
        template: this.sumUp,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'stockManagement',
        displayed: true,
        translationKey: 'Stock Management',
        template: this.stockManagement,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'sticker',
        displayed: true,
        translationKey: 'Sticker',
        template: this.sticker,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'worldLine',
        displayed: true,
        translationKey: 'Worldline',
        template: this.worldLine,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'tapToPayHelp',
        displayed: true,
        translationKey: 'TapToPayHelp',
        template: this.tapToPayHelp,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      }
    ]

  }

  onTableReset() {
    if (this.currentStatus) {
      this.filters.status = this.currentStatus.toString();
    }
  }

  getSoftwareTypes(software, type: 'waiter' | 'cashregister' | 'maindevice' | 'printer' | 'fiscal') {
    switch (type) {
      case 'waiter':
        const waiters = software.filter(s => s.softwareType.id === 1)[0]
        return waiters ? waiters.quantity : 0;
      case 'cashregister':
        const cashregisters = software.filter(s => s.softwareType.id === 2)[0]
        return cashregisters ? cashregisters.quantity : 0;
      case 'maindevice':
        const maindevices = software.filter(s => s.softwareType.id === 3)[0]
        return maindevices ? maindevices.quantity : 0;
      case 'printer':
        const printers = software.filter(s => s.softwareType.id === 4)[0]
        return printers ? printers.quantity : 0;
      case 'fiscal':
        const fiscalprinters = software.filter(s => s.softwareType.id === 5)[0]
        return fiscalprinters ? fiscalprinters.quantity : 0;
    }
  }

  getDeviceTypes(requestedDevices, type: 'phone' | 'tablet') {
    if (type === 'phone') {
      const phones = requestedDevices.find(d => d.deviceTypes.id === 1);
      return phones ? phones.quantity : 0;
    } else {
      const tablets = requestedDevices.find(d => d.deviceTypes.id === 2);
      return tablets ? tablets.quantity : 0;
    }
  }

  getAdditionalCosts(eventId, type: number) {
    const eventAdditionalCosts = this.additionalCosts.filter(a => a.eventId === eventId && a.id === type)[0];
    return eventAdditionalCosts ? eventAdditionalCosts.quantity : 0;
  }

  getFullPrice(eventId) {
    const eventOffer = this.eventOffers.filter(e => e.event?.id === eventId)[0];
    return eventOffer ? eventOffer.fullPrice : 0;
  }

  getEventDays(startDate, endDate) {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    return Math.floor((+date2 - +date1) / (1000 * 60 * 60 * 24));
  }

  exportData() {

    let element = document.getElementById('filterTable');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'Export Events.xlsx');

  }

}
